import OrderedArray from './collections/ordered-array';
import SettingsCollection from './extension/internal/settings-collection';

export default {
	OrderedArray,
	SettingsCollection,
};
